/* SCC welcome pop-up. One deck at a time, from its real print art: tap a deck to deal it, tap the card (or Back/Front)
   to flip it, and the deck name links to that deck.
   Shows once per visitor: after 15 s, 50% scroll, or exit intent, and never in a visit where another prompt already showed. A dismissed visitor sees the small tab instead for 14 days.
   Add ?sccw=1 to any URL to open it on demand (for testing). */
(function () {
  'use strict';
  if (window.__sccw) return;
  window.__sccw = true;

  var root = document.getElementById('sccw');
  var dataEl = document.getElementById('sccw-data');
  if (!root || !dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var DAY = 864e5;
  var box = root.querySelector('.sccw__box');
  var form = document.getElementById('sccw-form');
  var email = document.getElementById('sccw-email');
  var tags = root.querySelector('[data-sccw-tags]');
  var err = root.querySelector('[data-sccw-err]');
  var submit = root.querySelector('[data-sccw-submit]');
  var tab = document.getElementById('sccw-tab');
  var chips = [].slice.call(root.querySelectorAll('.sccw__chip'));
  var table = 'western';
  var lastFocus = null, opened = false, autoShown = false, artReady = null;

  function ls(k, v) {
    try {
      if (v === undefined) return window.localStorage.getItem(k);
      if (v === null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function ss(k, v) {
    try {
      if (v === undefined) return window.sessionStorage.getItem(k);
      if (v === null) window.sessionStorage.removeItem(k); else window.sessionStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function joined() { return ls('sccw_joined') === '1'; }
  function recentlyDismissed() { var t = +ls('sccw_dismissed') || 0; return Date.now() - t < 14 * DAY; }
  function tabHidden() { var t = +ls('sccw_tab_hidden') || 0; return Date.now() - t < 7 * DAY; }

  /* ---------- the one card on the table ---------- */
  var cardBtn = root.querySelector('[data-sccw-card]'), backEl = root.querySelector('[data-sccw-back]'), frontEl = root.querySelector('[data-sccw-front]');
  var sideBtns = [].slice.call(root.querySelectorAll('[data-sccw-side]')), deckLink = root.querySelector('[data-sccw-decklink]'), deckName = root.querySelector('[data-sccw-deckname]');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches, flipT = null;
  function artStyle(t, side) {
    if (t.sprite) return 'background-image:url(' + t.sprite + ');background-size:1400% 400%;background-position:' + (side === 'back' ? '100% 0' : '0 0');
    return 'background-image:url(' + (side === 'back' ? t.back : t.front) + ');background-size:cover;background-position:center';
  }
  function side(which) {
    cardBtn.classList.toggle('is-front', which === 'front');
    sideBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-sccw-side') === which ? 'true' : 'false'); });
  }
  function show(id, deal) {
    var t = D.tables[id]; if (!t) return;
    clearTimeout(flipT);
    var paint = function () {
      backEl.setAttribute('style', artStyle(t, 'back')); frontEl.setAttribute('style', artStyle(t, 'front'));
      deckName.textContent = t.deck + (t.avail === false ? ' (sold out)' : '');
      deckLink.href = t.url;
      side('back');
      if (!reduce) flipT = setTimeout(function () { side('front'); }, 900);
    };
    if (deal && !reduce) {
      cardBtn.classList.add('is-out');
      setTimeout(function () { paint(); cardBtn.classList.remove('is-out'); cardBtn.classList.add('is-in'); setTimeout(function () { cardBtn.classList.remove('is-in'); }, 450); }, 220);
    } else paint();
  }
  cardBtn.addEventListener('click', function () { clearTimeout(flipT); side(cardBtn.classList.contains('is-front') ? 'back' : 'front'); });
  sideBtns.forEach(function (b) { b.addEventListener('click', function () { clearTimeout(flipT); side(b.getAttribute('data-sccw-side')); }); });
  function tabCard() { var c = tab && tab.querySelector('[data-sccw-tabcard]'); if (c) c.setAttribute('style', artStyle(D.tables[table] || D.tables.western, 'back')); }

  function focusables() {
    return [].filter.call(box.querySelectorAll('button, a[href], input:not([type="hidden"])'), function (el) {
      return el.offsetParent !== null && !el.disabled;
    });
  }
  function open(step) {
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    show(table, false);
    setStep(step || (joined() ? 'done' : 'pick'));
    if (tab) tab.hidden = true;
    root.hidden = false;
    document.documentElement.classList.add('sccw-lock');
    void root.offsetWidth;
    root.classList.add('is-open');
    setTimeout(function () {
      if (step === 'done') { var h = root.querySelector('[data-sccw-hi]'); if (h) h.focus(); }
      else box.focus();
    }, 60);
  }
  function close() {
    if (!opened) return;
    opened = false;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('sccw-lock');
    setTimeout(function () { root.hidden = true; }, 420);
    if (!joined()) {
      ls('sccw_dismissed', String(Date.now()));
      showTab();
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function showTab() {
    if (!tab || joined() || tabHidden()) return;
    tabCard();
    tab.hidden = false;
  }

  [].forEach.call(root.querySelectorAll('[data-sccw-close]'), function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (!opened) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === box)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  /* swipe the sheet down to close on phones */
  (function () {
    var y0 = null;
    box.addEventListener('touchstart', function (e) { if (window.innerWidth < 750 && e.touches.length === 1 && !e.target.closest('input, .sccw__panel')) y0 = e.touches[0].clientY; }, { passive: true });
    box.addEventListener('touchmove', function (e) { if (y0 == null) return; var dy = e.touches[0].clientY - y0; if (dy > 0) box.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
    box.addEventListener('touchend', function (e) { if (y0 == null) return; var dy = (e.changedTouches[0].clientY - y0); y0 = null; box.style.transform = ''; if (dy > 90) close(); });
  })();
  if (tab) {
    tab.querySelector('[data-sccw-open]').addEventListener('click', function () { open('pick'); });
    tab.querySelector('[data-sccw-tabclose]').addEventListener('click', function () {
      tab.hidden = true;
      ls('sccw_tab_hidden', String(Date.now()));
    });
  }

  function pick(id) {
    if (!D.tables[id]) return;
    table = id;
    chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-table') === id ? 'true' : 'false'); });
    tags.value = 'newsletter,welcome-popup,table-' + id;
    if (opened) show(id, true);
  }
  chips.forEach(function (c) { c.addEventListener('click', function () { pick(c.getAttribute('data-table')); }); });

  function setStep(step) {
    [].forEach.call(root.querySelectorAll('[data-sccw-step]'), function (el) { el.hidden = el.getAttribute('data-sccw-step') !== step; });
    root.classList.toggle('is-done', step === 'done');
    if (step === 'done') reveal();
  }

  function reveal() {
    var t = D.tables[table] || D.tables.western;
    root.querySelector('[data-sccw-hi]').textContent = t.hi;
    var shop = root.querySelector('[data-sccw-shop]');
    shop.href = t.url;
    root.querySelector('[data-sccw-shoplabel]').textContent = (t.avail === false ? 'See the ' : 'Shop the ') + t.deck + ' deck';
    show(table, false);
  }

  var copyBtn = root.querySelector('[data-sccw-copy]');
  copyBtn.addEventListener('click', function () {
    function ok() { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy'; }, 2200); }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(D.code).then(ok, function () { window.prompt('', D.code); });
      else window.prompt('', D.code);
    } catch (e) { window.prompt('', D.code); }
  });

  function success() {
    ls('sccw_joined', '1');
    ls('sccw_dismissed', null);
    ss('sccw_pending', null);
    try { if (window.gtag) window.gtag('event', 'generate_lead', { method: 'welcome_popup', table: table }); } catch (e) {}
    setStep('done');
    var h = root.querySelector('[data-sccw-hi]');
    if (h) h.focus();
  }
  function fail(msg) {
    err.textContent = msg;
    err.hidden = false;
    submit.removeAttribute('aria-busy');
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    err.hidden = true;
    var v = (email.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { fail('Please enter a valid email address.'); email.focus(); return; }
    if (submit.getAttribute('aria-busy') === 'true') return;
    submit.setAttribute('aria-busy', 'true');
    email.value = v;
    if (!window.fetch) { ss('sccw_pending', table); form.submit(); return; }
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(function (r) {
        if (/\/challenge/.test(r.url)) { ss('sccw_pending', table); form.submit(); return; }
        if (!r.ok) throw new Error('http ' + r.status);
        success();
      })
      .catch(function () { ss('sccw_pending', table); form.submit(); });
  });

  var q = window.location.search;
  var pending = ss('sccw_pending');
  if (pending && /customer_posted=true/.test(q)) {
    pick(pending);
    ls('sccw_joined', '1');
    ss('sccw_pending', null);
    open('done');
    return;
  }
  if (/[?&]sccw=1/.test(q)) { open('pick'); return; }
  if (joined()) return;
  if (recentlyDismissed()) { showTab(); return; }

  function auto() {
    if (autoShown || opened) return;
    /* one prompt per visit: skip if another SCC sheet (post-purchase, win card) is open or already showed this visit */
    try { if (window.sessionStorage.getItem('scc-pop')) return; } catch (e) {}
    if (document.querySelector('.scf-sheet, .scf-ov')) return;
    if (document.querySelector('cart-drawer.active, .menu-drawer-container[open], details[open] > .search-modal')) { autoShown = false; setTimeout(auto, 4000); return; }
    autoShown = true;
    try { window.sessionStorage.setItem('scc-pop', '1'); } catch (e) {}
    open('pick');
  }
  setTimeout(auto, 15000);
  window.addEventListener('scroll', function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && window.scrollY / h > 0.5) { window.removeEventListener('scroll', onScroll); auto(); }
  }, { passive: true });
  if (window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
    setTimeout(function () {
      document.addEventListener('mouseout', function onOut(e) {
        if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); auto(); }
      });
    }, 3000);
  }
})();
